import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "mt-0" }
const _hoisted_2 = { class: "grid gap-4 grid-cols-1 md:grid-cols-[1fr_250px] xl:grid-cols-5 lg:gap-8 z-40 relative mt-[14rem] px-4" }
const _hoisted_3 = { class: "grid auto-rows-max items-start gap-4 col-span-2 lg:col-span-2 lg:gap-8" }
const _hoisted_4 = { class: "grid gap-6 pt-[240px] relative" }
const _hoisted_5 = { class: "space-y-6" }
const _hoisted_6 = { class: "grid grid-cols-2 gap-4 pt-4" }
const _hoisted_7 = { class: "sm:grid auto-rows-max items-start gap-4 lg:gap-8 sm:col-span-3" }

import { Card, CardHeader, CardContent } from '@/components/ui/card'

export default /*@__PURE__*/_defineComponent({
  __name: 'EditCourseSkeleton',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "absolute w-full left-0 right-0 h-80 bg-zinc-800 animate-pulse" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(Card), null, {
          default: _withCtx(() => [
            _createVNode(_unref(CardContent), null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _cache[2] || (_cache[2] = _createElementVNode("div", { class: "absolute left-1/2 -translate-x-1/2 -top-[130px]" }, [
                    _createElementVNode("div", { class: "w-[250px] h-[333px] rounded-lg shadow-xl animate-pulse bg-zinc-700" })
                  ], -1)),
                  _createElementVNode("div", _hoisted_5, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (i) => {
                      return _createElementVNode("div", {
                        key: i,
                        class: "space-y-2"
                      }, _cache[0] || (_cache[0] = [
                        _createElementVNode("div", { class: "h-4 w-20 animate-pulse bg-zinc-700 rounded" }, null, -1),
                        _createElementVNode("div", { class: "h-10 w-full animate-pulse bg-zinc-700 rounded" }, null, -1)
                      ]))
                    }), 64)),
                    _createElementVNode("div", _hoisted_6, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (i) => {
                        return _createElementVNode("div", {
                          key: i,
                          class: "h-8 w-full rounded-full animate-pulse bg-zinc-700"
                        })
                      }), 64))
                    ]),
                    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "h-10 w-full mt-6 animate-pulse bg-zinc-700 rounded" }, null, -1))
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (i) => {
          return _createVNode(_unref(Card), { key: i }, {
            default: _withCtx(() => [
              _createVNode(_unref(CardHeader), null, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createElementVNode("div", { class: "h-6 w-32 animate-pulse bg-zinc-700 rounded" }, null, -1)
                ])),
                _: 1
              }),
              _createVNode(_unref(CardContent), { class: "space-y-4" }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createElementVNode("div", { class: "h-10 w-full animate-pulse bg-zinc-700 rounded" }, null, -1),
                  _createElementVNode("div", { class: "h-10 w-full animate-pulse bg-zinc-700 rounded" }, null, -1)
                ])),
                _: 1
              })
            ]),
            _: 2
          }, 1024)
        }), 64))
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_unref(Card), null, {
          default: _withCtx(() => [
            _createVNode(_unref(CardHeader), null, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createElementVNode("div", { class: "flex justify-between items-center" }, [
                  _createElementVNode("div", { class: "h-6 w-24 animate-pulse bg-zinc-700 rounded" }),
                  _createElementVNode("div", { class: "h-10 w-24 animate-pulse bg-zinc-700 rounded" })
                ], -1)
              ])),
              _: 1
            }),
            _createVNode(_unref(CardContent), { class: "space-y-4" }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
                  return _createElementVNode("div", {
                    key: i,
                    class: "flex items-center justify-between p-4 border border-zinc-800 rounded-lg"
                  }, _cache[6] || (_cache[6] = [
                    _createElementVNode("div", { class: "flex items-center gap-4" }, [
                      _createElementVNode("div", { class: "h-10 w-10 rounded animate-pulse bg-zinc-700" }),
                      _createElementVNode("div", { class: "space-y-2" }, [
                        _createElementVNode("div", { class: "h-4 w-32 animate-pulse bg-zinc-700 rounded" }),
                        _createElementVNode("div", { class: "h-3 w-48 opacity-50 animate-pulse bg-zinc-700 rounded" })
                      ])
                    ], -1),
                    _createElementVNode("div", { class: "flex gap-2" }, [
                      _createElementVNode("div", { class: "h-8 w-8 rounded-full animate-pulse bg-zinc-700" }),
                      _createElementVNode("div", { class: "h-8 w-8 rounded-full animate-pulse bg-zinc-700" }),
                      _createElementVNode("div", { class: "h-8 w-8 rounded-full animate-pulse bg-zinc-700" })
                    ], -1)
                  ]))
                }), 64))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})